import type { Integration } from '@hostesa/api-client';
import { useT } from '@hostesa/i18n';
import { StatusBadge, type StatusVariant } from '@hostesa/ui';
import { namespace } from './i18n';

type IntegrationStatus = Integration['status'];

/** Map the backend lifecycle status to a StatusBadge variant (color + text). */
const statusVariant: Record<IntegrationStatus, StatusVariant> = {
  not_configured: 'neutral',
  configured: 'pending',
  testing: 'pending',
  active: 'active',
  degraded: 'warning',
  auth_failed: 'error',
  disabled: 'inactive',
};

export interface ConnectionStatusProps {
  status: IntegrationStatus;
  'data-testid'?: string;
}

/**
 * Connection status indicator. Always renders BOTH a translated text label and
 * a colored dot via StatusBadge — never color alone (a11y + brand hard rule).
 */
export function ConnectionStatus({ status, 'data-testid': testId }: ConnectionStatusProps) {
  const { t } = useT(namespace);
  return (
    <StatusBadge
      data-testid={testId ?? 'integration-connection-status'}
      status={statusVariant[status]}
      label={t(`status.${status}`)}
    />
  );
}
